import { Bitstring } from './Bitstring';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
class StatusList {
  static {
    __name(this, "StatusList");
  }
  bitstring;
  length;
  constructor({ length, buffer }) {
    this.bitstring = new Bitstring({
      length,
      buffer
    });
    this.length = this.bitstring.length;
  }
  setStatus(index, status) {
    if (typeof status !== "boolean") {
      throw new TypeError('"status" must be a boolean.');
    }
    return this.bitstring.set(index, status);
  }
  getStatus(index) {
    return this.bitstring.get(index);
  }
  async encode() {
    return await this.bitstring.encodeBits();
  }
  static async decode({ encodedList }) {
    try {
      const buffer = await Bitstring.decodeBits({
        encoded: encodedList
      });
      return new StatusList({
        buffer
      });
    } catch (e) {
      if (e instanceof Error) {
        throw e;
      }
      throw new Error(`Could not decode encoded status list; reason: ${e}`);
    }
  }
}

export { StatusList };
